var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8151 17.1547H1.18547C0.959545 17.1547 0.742873 17.065 0.58312 16.9052C0.423367 16.7455 0.333618 16.5288 0.333618 16.3029V0.969547C0.333618 0.743622 0.423367 0.52695 0.58312 0.367196C0.742873 0.207443 0.959545 0.117695 1.18547 0.117695H14.8151C15.041 0.117695 15.2577 0.207443 15.4175 0.367196C15.5772 0.52695 15.667 0.743622 15.667 0.969547V16.3029C15.667 16.5288 15.5772 16.7455 15.4175 16.9052C15.2577 17.065 15.041 17.1547 14.8151 17.1547ZM4.59288 6.08066V7.78436H11.4077V6.08066H4.59288ZM4.59288 9.48806V11.1918H11.4077V9.48806H4.59288Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillss);
export default __webpack_public_path__ + "static/media/Billss.c8bdd743dad5c4f440a46babc4a5dfd6.svg";
export { ForwardRef as ReactComponent };